module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABVElEQVQ4T93UQSgEURjA8f+3baIoxYmU4iKRvIPc5OLI3cUNOYlykGnMlBJxE0cXZ25uLgq174CbUopysErtQYn5NG27zU4z1tZeeMd53/d77/vmvSfUeUidPf4BOLqoTR8tPAJt5fYoS9aXnaR2pZfsasYE3AE9qX1Wpq0vR9H5RNA4egmM1PDDxq0nZ2F8BWhcbSfgpQYoGnpvPemtBB3NR3oVAJkq+BvQWoqxnkgc1AgwYz05NGu6jLAVg18bCnRd7Mq7cbScUw0sGsqg9eXWOLoNLJChy7qSN44eA5PRhX4HFjO+skL31bo8DTu6LzCb1IpawDD/2noyFC0xjv5NcA+YTzkqtZccQsbRU2AiBd0EVhLnPumwG/KcepeNozfAQLVbIzCV8+SkFPfjezjmarYQ8AB0xmGBuZwnBwnfq+0B+l1tbgw4B/pQVq0v4SFPHN9M/YYVYsRb0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about-c_icon_hy_sel.png
// module id = jHiL
// module chunks = 1